import React, { useEffect, useState } from 'react';


export default function SplashScreen({ onComplete }) {
  const [animationPhase, setAnimationPhase] = useState('spinning');

  useEffect(() => {
    const timer1 = setTimeout(() => setAnimationPhase('tagline'), 1200);
    const timer2 = setTimeout(() => setAnimationPhase('complete'), 2800);
    const timer3 = setTimeout(() => onComplete(), 3400);
    return () => { clearTimeout(timer1); clearTimeout(timer2); clearTimeout(timer3); };
  }, [onComplete]);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center z-50"
      style={{ background: 'var(--color-primary)' }}>
      <div className="flex flex-col items-center gap-6">
        {/* Spinning Coin */}
        <div className="relative flex items-center justify-center"
          style={{
            width: 120, height: 120,
            animation: animationPhase === 'spinning' ? 'coinSpin 1.2s ease-in-out' : 'none',
          }}>
          <style>{`
            @keyframes coinSpin {
              0% { transform: rotateY(0deg) scale(0.5); opacity: 0; }
              40% { transform: rotateY(360deg) scale(1.1); opacity: 1; }
              70% { transform: rotateY(720deg) scale(1); opacity: 1; }
              100% { transform: rotateY(720deg) scale(1); opacity: 1; }
            }
            @keyframes goldPulse {
              0%, 100% { box-shadow: 0 0 20px rgba(212,165,32,0.4); }
              50% { box-shadow: 0 0 40px rgba(212,165,32,0.8); }
            }
            @keyframes fadeInUp {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
            }
            @keyframes shimmer {
              0% { background-position: -200% center; }
              100% { background-position: 200% center; }
            }
          `}</style>
          <img
            src="/assets/images/Golden_coins_Win_Logo-1772863636273.png"
            alt="WIN gold coin - Women Investment Network"
            style={{
              width: 120, height: 120,
              borderRadius: '50%',
              objectFit: 'cover',
              animation: 'goldPulse 2s ease-in-out infinite',
              animationDelay: '1.2s',
            }}
          />
        </div>

        {/* Brand Name */}
        <div className="text-center" style={{ animation: 'fadeInUp 0.6s ease forwards', animationDelay: '0.8s', opacity: 0 }}>
          <div style={{
            fontFamily: 'var(--font-heading)', fontSize: '3rem', fontWeight: 700,
            letterSpacing: '0.3em', color: '#FFFFFF', lineHeight: 1,
          }}>WIN</div>
          <div style={{
            fontFamily: 'var(--font-caption)', fontSize: '0.75rem', letterSpacing: '0.2em',
            color: 'rgba(212,175,55,0.9)', marginTop: 6, textTransform: 'uppercase',
          }}>Women Invest Network</div>
        </div>

        {/* Tagline */}
        {(animationPhase === 'tagline' || animationPhase === 'complete') && (
          <div style={{
            fontFamily: 'var(--font-body)', fontSize: '1.125rem', fontStyle: 'italic',
            color: 'rgba(255,255,255,0.85)', animation: 'fadeInUp 0.5s ease forwards',
            textAlign: 'center',
          }}>
            "Invest In Each Other™"
          </div>
        )}

        {/* Loading dots */}
        <div className="flex gap-2 mt-4">
          {[0, 1, 2]?.map(i => (
            <div key={i} className="rounded-full"
              style={{
                width: 8, height: 8,
                background: 'var(--color-accent)',
                animation: `goldPulse 1s ease-in-out infinite`,
                animationDelay: `${i * 0.2}s`,
                opacity: 0.7,
              }} />
          ))}
        </div>
      </div>
    </div>
  );
}